export const WISHLIST_REQUEST = 'wishlist/request'
export const WISHLIST_ERROR = 'wishlist/error'
export const WISHLIST_SUCCESS = 'wishlist/success'
export const WISHLIST_ADD_SUCCESS = 'wishlist/addSuccess'
export const WISHLIST_REMOVE_SUCCESS = 'wishlist/removeSuccess'
